import React from 'react'
import './tourband.css'
import Wave from '../wave/Wave'
import { useTour } from '../tour/TourContext'
import peek from '../../assets/kids_2.JPG'

export default function TourBand() {
  const { openVideo, openRequest } = useTour()

  return (
    <section className="tourband">
      <div className="tourband-inner">
        <div className="tourband-copy">
          <span className="section-eyebrow">See it for yourself</span>
          <h2 className="section-title">Take a peek inside our school</h2>
          <p>
            Step into our classrooms from home. Watch our virtual tour, then come say hello in
            person. We'd love to show you around.
          </p>
          <div className="tourband-actions">
            <button type="button" className="btn btn-white" onClick={openVideo}>
              Watch the Tour
            </button>
            <button type="button" className="btn tourband-yellow" onClick={openRequest}>
              Schedule a Visit
            </button>
          </div>
        </div>

        <button type="button" className="tourband-card" onClick={openVideo} aria-label="Play the virtual tour video">
          <img src={peek} alt="" />
          <span className="tourband-play" aria-hidden="true">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="44" height="44" fill="currentColor">
              <path d="M8 5.5v13a1 1 0 0 0 1.5.86l10.5-6.5a1 1 0 0 0 0-1.72L9.5 4.64A1 1 0 0 0 8 5.5Z" />
            </svg>
          </span>
        </button>
      </div>
      <Wave color="var(--mint)" />
    </section>
  )
}
